import { useState, useEffect } from 'react';

/**
 * useState that persists to localStorage.
 * Falls back to defaultValue when localStorage is empty or unavailable.
 */
export default function usePersistedState(key, defaultValue) {
  const [state, setState] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved !== null ? JSON.parse(saved) : defaultValue;
    } catch { return defaultValue; }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch { /* localStorage full or unavailable */ }
  }, [key, state]);

  return [state, setState];
}
